<template>
  <div class="cross" v-on:click="home">
    <svg version="1.1" baseProfile="tiny" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    	 x="0px" y="0px" width="20px" height="20px" viewBox="0 0 20 20" xml:space="preserve">
    <line fill="#FFFFFF" stroke="#000000" stroke-width="2" stroke-miterlimit="10" x1="0.5" y1="0.5" x2="19.4" y2="19.4"/>
    <line fill="#FFFFFF" stroke="#000000" stroke-width="2" stroke-miterlimit="10" x1="19.4" y1="0.5" x2="0.5" y2="19.4"/>
    </svg>

  </div>
  <!-- <router-link v-on:click.native.stop="home" class="cross" to="/">╳</router-link> -->

</template>
<script>
  export default {
    data () {
      return {}
    },
    methods: {
      home () {
        this.$emit("home-reset");
      }
    }
  };
</script>
<style lang="scss" scoped>
    @import "../global.scss";
    .cross {

      cursor: pointer;
      position: fixed;
      z-index: 10;
      top:1rem;
      right:1rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/Cross.vue